import Slider, { Settings } from 'react-slick'
import 'slick-carousel/slick/slick.css'
import React, { useRef } from 'react'
import clsx from 'clsx'
import { ReviewCard } from '@/components/molecules/ReviewCard/ReviewCard'
import { ReviewSliderProps } from '@/components/molecules/ReviewsSlider/types'
import { SliderButtonsTranslation } from '@/helpers/getSliderButtonsTranslation'

export function ReviewsSlider({ reviews }: ReviewSliderProps) {
  const sliderRef = useRef<Slider>(null)
  const gotoNext = () => sliderRef?.current?.slickNext()
  const gotoPrev = () => sliderRef?.current?.slickPrev()

  const SLIDER_SETTINGS: Settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: reviews.length > 3 && true,
    autoplaySpeed: 20000,
    speed: 500,
    initialSlide: 0,
    slidesToShow: 3,
    slidesToScroll: 3,
    variableWidth: true,
    // eslint-disable-next-line react/no-unstable-nested-components
    appendDots: (dots: React.ReactNode): React.JSX.Element => (
      <div>
        <div className="flex justify-center items-center gap-16 mt-24 netbook:mt-32">
          <button type="button" onClick={gotoPrev} aria-label={SliderButtonsTranslation.previous}>
            <i className="block fa fa-slider-arrow text-xl m-auto" aria-hidden="true" />
          </button>
          <ul className="flex justify-center items-center gap-16 my-20">{dots}</ul>
          <button type="button" onClick={gotoNext} aria-label={SliderButtonsTranslation.next}>
            <i className="block fa fa-slider-arrow rotate-180 text-xl" aria-hidden="true" />
          </button>
        </div>
      </div>
    ),
    // eslint-disable-next-line react/no-unstable-nested-components
    customPaging: (index: number): React.JSX.Element => (
      <span key={index} className={clsx('block h-8 w-8 rounded-full cursor-pointer', {})} />
    ),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  return (
    <div className="slider-container">
      <Slider {...SLIDER_SETTINGS} ref={sliderRef} className="w-full h-full">
        {reviews.length > 0 &&
          reviews.map((review) => (
            <ReviewCard
              date={review.date}
              key={review._uid}
              position={review.position}
              author={review.author}
              content={review.content}
              rating={review.rating}
            />
          ))}
      </Slider>
    </div>
  )
}
